import React from 'react';
import { ActionBar } from '@core/ui';
import * as Icons from '@ant-design/icons';

import { HeaderButton, HeadPortal } from '@modules/layout';

import { useBranchInspectionsActionBar } from '../hooks/use-branch-inspections-action-bar';
import { useAuth } from '@modules/auth';

export const BranchInspectionsActionBar = () => {
  const { selection, resetSelection, create, selectAll, reset, fetch } = useBranchInspectionsActionBar();
  const { can } = useAuth();

  const selectAllButton = (
    <HeaderButton onClick={selectAll} icon={<Icons.CheckCircleOutlined />}>
      Hamısını seç
    </HeaderButton>
  );

  const resetSelectionButton = (
    <HeaderButton onClick={resetSelection} icon={<Icons.CloseCircleOutlined />}>
      {selection.length} sətir seçilib
    </HeaderButton>
  );

  return (
    <HeadPortal>
      <ActionBar>
        {can('branch_inspection_create') && (
          <HeaderButton onClick={create} icon={<Icons.PlusCircleOutlined />}>
            Yeni
          </HeaderButton>
        )}
        {!selection.length ? selectAllButton : resetSelectionButton}
        <HeaderButton onClick={fetch} icon={<Icons.ReloadOutlined />}>
          Yenilə
        </HeaderButton>
        <HeaderButton onClick={reset} icon={<Icons.ClearOutlined />}>
          Sıfırla
        </HeaderButton>
      </ActionBar>
    </HeadPortal>
  );
};
